import { render, staticRenderFns } from "./BenefitsMoments.vue?vue&type=template&id=07d0bd43&"
import script from "./BenefitsMoments.vue?vue&type=script&lang=js&"
export * from "./BenefitsMoments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports